export const AclPermission = {
  READ: 'READ',
  WRITE: 'WRITE',
  DELETE: 'DELETE',
} as const;

export type AclPermission = (typeof AclPermission)[keyof typeof AclPermission];
